import { render, staticRenderFns } from "./Programme.vue?vue&type=template&id=94b604a8&scoped=true&"
import script from "./Programme.vue?vue&type=script&lang=js&"
export * from "./Programme.vue?vue&type=script&lang=js&"
import style0 from "./Programme.vue?vue&type=style&index=0&id=94b604a8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b604a8",
  null
  
)

export default component.exports